module.exports = __webpack_public_path__ + "static/img/年度最佳路由器.9dcacc77.png";